import PublisherPanelApp from "../../features/PublisherPanel/PublisherPanelApp";

const PublisherPanelPage = () => <PublisherPanelApp />;

export default PublisherPanelPage;
